import Axios from 'axios';
import server from 'util/Server';
import moment from 'moment';
import Swal from "sweetalert2"
import { sessionCaducada } from 'util/funciones'
import { objetoVacio } from 'util/utils';


const headers = {
    Authorization: server.obtenerToken(),
    versionapp: server.versionApp,
    versioncode: server.versionCode,
    fecha: moment().format(),
    aplicacion: server.aplicacion,
    identificadordispositivo: server.aplicacion
}
export const getNegocioPorEstacionService = async(empresas_id) => {
    return Axios.get(`${server.host}${server.puertoMovimiento}/api/movimiento/setNegocioEds/${empresas_id}}`, { headers: headers })
}

export const getReporte = async(data, reporte, tipoReporte) => {
    return new Promise(function(resolve, reject) {
        Axios.post(`${server.host}${server.puertoMovimiento}/api/reportes/${reporte}/${tipoReporte || 'ALL'}`, data, { headers: headers })
            .then((response) => {
                const datos = response.data.data
                if (datos != null) {
                    if (datos.length === 0) {
                        resolve([])
                        return;
                    } else {
                        resolve(datos)
                    }
                } else if (response.status === server.responseSesionCaducada) {
                    resolve([]);
                    sessionCaducada()
                } else {
                    resolve([])
                }
            })
            .catch((err) => {
                console.error(err);
                reject(err, undefined);
            });
    });

};
export const getReporteria = async(data, reporte, tipoReporte = '') => {
    return new Promise(function(resolve, reject) {
        Axios.post(`${server.host}${server.puertoMovimiento}/api/reporteria/${reporte}/${tipoReporte}`, data, { headers: headers })
            .then((response) => {
                const datos = response.data.data
                if (datos != null) {
                    if (datos.length === 0) {
                        resolve([])
                        return;
                    } else {
                        resolve(datos)
                    }
                } else if (response.status === server.responseSesionCaducada) {
                    resolve([]);
                    sessionCaducada()
                } else {
                    resolve([])
                }
            })
            .catch((err) => {
                console.error(err);
                reject(err, undefined);
            });
    });

}

export const getDepuracionPos = async(id, datos) => {
    return new Promise(function(resolve, reject) {
        Axios.post(`${server.host}${server.puertoMovimiento}/api/movimiento/find/debug/${id}`, datos)
            .then((response) => {
                const datos = response.data
                if (datos != null) {
                    if (datos.length === 0) {
                        Swal.fire({
                            icon: 'warning',
                            title: 'No se encontraron datos con las fechas seleccionadas',
                            text: 'Intente con otras fechas',
                        })
                        resolve([])
                        return;
                    } else {
                        resolve(datos)
                    }
                } else if (response.status === server.responseSesionCaducada) {
                    resolve([]);
                    sessionCaducada()
                } else {
                    resolve([])
                }
            })
            .catch((err) => {
                console.error(err);
                reject(err, undefined);
            });
    });

};

export const getDetallesDepuracionPos = async(id) => {
    return new Promise(function(resolve, reject) {
        Axios.get(`${server.host}${server.puertoMovimiento}/api/movimiento/find/debug/detallado/${id}`)
            .then((response) => {
                const datos = response.data
                if (datos != null) {
                    if (datos.length === 0) {
                        Swal.fire({
                            icon: 'warning',
                            title: 'No se encontraron datos con las fechas seleccionadas',
                            text: 'Intente con otras fechas',
                        })
                        resolve([])
                        return;
                    } else {
                        resolve(datos)
                    }
                } else if (response.status === server.responseSesionCaducada) {
                    resolve([]);
                    sessionCaducada()
                } else {
                    resolve([])
                }
            })
            .catch((err) => {
                console.error(err);
                reject(err, undefined);
            });
    });

};
export const getReporteMongo = async(data, jornada) => {
    return new Promise(function(resolve, reject) {
        Axios.post(`${server.host}${server.puertoMovimiento}/api/reportes/consolidado-turno/mongodb/${jornada}`, data, { headers: headers })
            .then((response) => {
                const datos = response.data.data
                if (datos != null) {
                    if (datos.length === 0) {
                        Swal.fire({
                            icon: 'warning',
                            title: 'No se encontraron datos con las fechas seleccionadas',
                            text: 'Intente con otras fechas',
                        })
                        resolve([])
                        return;
                    } else {
                        resolve(datos)
                    }
                } else if (response.status === server.responseSesionCaducada) {
                    resolve([]);
                    sessionCaducada()
                } else {
                    resolve([])
                }
            })
            .catch((err) => {
                console.error(err);
                reject(err, undefined);
            });
    });

};
export const getReporteCierreDiarioV2 = async(empresa, fecha) => {
    return new Promise(function(resolve, reject) {
        Axios.post(`${server.host}${server.puertoEquipo}/api/propiedad/obtener-consolidados/${empresa}/${fecha}`, {}, { headers: headers })
            .then((response) => {
                const datos = response.data.data
                if (datos != null) {
                    if (datos.length === 0) {
                        Swal.fire({
                            icon: 'warning',
                            title: 'No se encontraron datos con las fechas seleccionadas',
                            text: 'Intente con otras fechas',
                        })
                        resolve([])
                        return;
                    } else {
                        resolve(datos)
                    }
                } else if (response.status === server.responseSesionCaducada) {
                    resolve([]);
                    sessionCaducada()
                } else {
                    resolve([])
                }
            })
            .catch((err) => {
                console.error(err);
                reject(err, undefined);
            });
    });

};

export const getDetallesCompra = async(identificadorDetalle) => {
    return new Promise(function(resolve, reject) {
        Axios.get(`${server.host}${server.puertoCentury}/api/movimiento/detalles/${identificadorDetalle}`, { headers: headers })
            .then((response) => {
                const datos = response.data.mensaje
                if (datos != null) {
                    resolve(datos[0])
                } else if (response.status === server.responseSesionCaducada) {
                    resolve({});
                    sessionCaducada()
                } else {
                    resolve({})
                }
            })
            .catch((err) => {
                console.error(err);
                reject(err, undefined);
            });
    });

};

export const getKardexConsolidado = async(data) => {
    return new Promise(function(resolve, reject) {
        Axios.post(`${server.host}${server.puertoMovimiento}/api/reportes/kardex_consolidado/canastilla`, data, { headers: headers })
            .then((response) => {
                const datos = response.data.data
                if (datos != null) {
                    if (datos.length === 0) {
                        Swal.fire({
                            icon: 'warning',
                            title: 'No se encontraron datos con las fechas seleccionadas',
                            text: 'Intente con otras fechas',
                        })
                        resolve([])
                        return;
                    } else {
                        resolve(datos)
                    }
                } else if (response.status === server.responseSesionCaducada) {
                    resolve([]);
                    sessionCaducada()
                } else {
                    resolve([])
                }
            })
            .catch((err) => {
                console.error(err);
                reject(err, undefined);
            });
    });

};

export const getReporteEspecifico = async(data, reporte) => {
    return new Promise(function(resolve, reject) {
        Axios.post(`${server.host}${server.puertoMovimiento}/api/reportes/${reporte}`, data, { headers: headers })
            .then((response) => {
                const datos = response.data.data
                if (datos != null) {
                    if (datos.length === 0) {
                        Swal.fire({
                            icon: 'warning',
                            title: 'No se encontraron datos con las fechas seleccionadas',
                            text: 'Intente con otras fechas',
                        })
                        resolve([])
                        return;
                    } else {
                        resolve(datos)
                    }
                } else if (response.status === server.responseSesionCaducada) {
                    resolve([]);
                    sessionCaducada()
                } else {
                    resolve([])
                }
            })
            .catch((err) => {
                console.error(err);
                reject(err, undefined);
            });
    });

};

export const getClientes = async(empresasHijos) => {
    const data = {
        identificadorEstacion: empresasHijos
    }
    return new Promise(function(resolve, reject) {
        Axios.post(server.host + server.puertoCentury + "/api/cliente/select/", data, { headers: headers })
            .then((res) => {
                if (res.status === server.responseOK) {
                    const datos = res.data.data
                    if (datos != null && datos.length > 0) {
                        resolve(datos)
                    }
                } else if (res.status === server.responseSesionCaducada) {
                    sessionCaducada()
                }
            })
            .catch((err) => {
                console.error(err)
                reject([])
            })
    });
};


export const getClientServicesGnv = async (params) => {
  return Axios.get(server?.host + server.puertoClientMS + `/api/v1/customer/all`, { params,headers: { Authorization: server.obtenerToken() } })
}
export const getTotalizadoVentasGnv = async (query) => {
  return Axios.get(server?.host + server.puerto_reporte_service + `/api/recaudos/total-ventas` ,  { params: query ,  headers: { Authorization: server.obtenerToken() } })
}

export const getCalibraciones = (data) => {
    return new Promise(function(resolve, reject) {
        Axios.post(`${server.host}${server.puertoMovimiento}/api/movimiento/obtener/calibracion`, data, { headers: headers })
            .then((response) => {
                const datos = response.data.data
                if (datos != null) {
                    if (datos.length === 0) {
                        Swal.fire({
                            icon: 'warning',
                            title: 'No se encontraron datos con las fechas seleccionadas',
                            text: 'Intente con otras fechas',
                        })
                        resolve([])
                        return;
                    } else {
                        resolve(datos)
                    }
                } else if (response.status === server.responseSesionCaducada) {
                    resolve([]);
                    sessionCaducada()
                } else {
                    resolve([])
                }
            })
            .catch((err) => {
                console.error(err);
                reject(err, undefined);
            });
    });
}

export const getInventario = async(tipo, empresasId) => {

    return new Promise(function(resolve, reject) {
        Axios.get(`${server.host}${server.puertoMovimiento}/api/reportes/reporte/${tipo}/${empresasId}`, { headers: headers })
            .then((response) => {
                const datos = response.data.data
                if (datos) {
                    resolve(datos)
                } else if (response.status === server.responseSesionCaducada) {
                    resolve([]);
                    sessionCaducada()
                }
            })
            .catch((err) => {
                console.error(err);
                reject(err, undefined);
            });
    });

};

// CIERRE DIARIO NUEVA PETICION
export const getCierreDiario = async(datos) => {
    return new Promise(function(resolve, reject) {
        Axios.post(`${server.host}10445/api/reportes/cierre-diario`, datos, { headers: {} })
            .then((response) => {
                const datos = response.data.data
                if (datos != null) {
                    resolve(datos)
                } else if (response.status === server.responseSesionCaducada) {
                    resolve([]);
                    sessionCaducada()
                } else {
                    resolve([])
                }
            })
            .catch((err) => {
                console.error(err);
                reject(err, undefined);
            });
    });
};

export const getRemisionesElectronicas = async(datos) => {
    return new Promise(function(resolve, reject) {
        Axios.post(`${server.host}${server.puertoMovimiento}/api/reportes/comprobantes/ventas/fe`, datos, { headers: headers })
            .then((response) => {
                const datos = response.data.data
                if (datos != null) {
                    resolve(datos.map((remision) => ({...remision, detallado: objetoVacio(JSON.parse(remision.detallado)) ? [] : JSON.parse(remision.detallado), razon_social: '' })))
                } else if (response.status === server.responseSesionCaducada) {
                    resolve([]);
                    sessionCaducada()
                } else {
                    resolve([])
                }
            })
            .catch((err) => {
                console.error(err);
                reject(err, undefined);
            });
    });
};


export const getExcelReporteVentasByEds = async data => {
    return new Promise(function(resolve, reject) {
        Axios.post(`${server.host}${server.puertoMovimiento}/api/reportes/exportarReporte`, data, {
                responseType: 'arraybuffer',
                headers: headers
            })
            .then(response => {
                const datos = response.data
                if (datos != null) {
                    if (datos.length === 0) {
                        Swal.fire({
                            icon: 'warning',
                            title: 'No se encontraron datos con las fechas seleccionadas',
                            text: 'Intente con otras fechas'
                        })
                        resolve([])
                        return
                    } else {
                        console.log('bufffeerr', datos)
                        resolve(datos)
                    }
                } else if (response.status === server.responseSesionCaducada) {
                    resolve([])
                    sessionCaducada()
                } else {
                    resolve([])
                }
            })
            .catch(err => {
                console.error(err)
                reject(err, undefined)
            })
    })
}
